import { useMutation } from "@tanstack/react-query";
import { PostBudgetRequest, BudgetValidationErrorResponse } from "@norma-bi/bi-api";
import { useRootAPI } from "@/api";

export function useUploadBudget() {
  const rootAPI = useRootAPI();

  return useMutation<void, BudgetValidationErrorResponse, PostBudgetRequest>({
    mutationFn: async (args: PostBudgetRequest) => {
      await rootAPI.postBudget(args);
    },
    onError: (error: BudgetValidationErrorResponse) => {
      console.error("Upload error:", error);
    },
  });
}
